// packageFormHelpers — shared helpers for `PackageEditFormBody`. Extracted
// to its own non-TSX module so it can co-export non-component runtime
// constants without tripping `react-refresh/only-export-components`.
//
// PRD: Ralph/VqeDdlEdit/PRD.md § Slice D7 — oracle packages variant.

import type { PackageKindShell } from '../../../../sql-resolver/types/ddlEdit';

export type PackageEditMode = 'create' | 'alter';

export interface PackageFormValues {
  readonly kind: PackageKindShell;
  readonly name: string;
  readonly bodyText: string;
  readonly orReplace: boolean;
  readonly oracleEditionable: boolean;
  readonly oracleNonEditionable: boolean;
  readonly compileBody: boolean;
}

export const DEFAULT_PACKAGE_FORM_VALUES: PackageFormValues = {
  kind: 'spec',
  name: '',
  bodyText: '',
  orReplace: false,
  oracleEditionable: false,
  oracleNonEditionable: false,
  compileBody: false,
};
